if (typeof window.auditMode === 'undefined') {
  window.auditMode = false
}

if (typeof window.currentBalances === 'undefined') {
  window.currentBalances = {}
}

const onAccountBalanceInvoicePageMatch = () => {
  console.log('Lux Inject: Running onAccountBalanceInvoicePageMatch v8')

  const path = window.location.pathname
  const regex =
    /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+\/invoice\/edit/
  const user = !!path.match(regex) ? 'administrator' : 'advisory council'

  // --- Configuration ---
  const anchorSelector =
    user === 'advisory council' ? '.section-header' : '#scrollElement' // Element to insert the UI before
  const containerId = 'lux-invoice-balances-section' // Renamed for clarity
  const localStorageKey = 'lux_balanceDateRange'

  // --- Global State ---
  let mainContainer = null // Reference to the injected container div
  let currentBalances = [] // Holds the array of fetched balances for the current view
  let activeController = null // Holds the controller instance ONLY during an edit/approve action
  let currentDateRange = { startDate: null, endDate: null } // Store loaded date range

  // --- Date Formatting Helper ---
  function formatDate(dateString) {
    if (!dateString) return 'N/A'
    try {
      // Basic YYYY-MM-DD to locale date string
      const [year, month, day] = dateString.split('-')
      const date = new Date(year, month - 1, day) // Month is 0-indexed
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    } catch (e) {
      console.error('Error formatting date:', dateString, e)
      return dateString // Return original if formatting fails
    }
  }

  // --- UI Rendering ---
  function renderUI(balances) {
    if (!mainContainer) return

    mainContainer.innerHTML = '' // Clear previous content (loading message or old UI)

    console.log(`Rendering UI. Balances count: ${balances.length}`)

    renderView(balances)

    // Attach the single delegated listener AFTER rendering
    // Remove previous listener if it exists to prevent duplicates
    mainContainer.removeEventListener('click', handleDelegatedClick)
    mainContainer.addEventListener('click', handleDelegatedClick)
  }

  /*function renderCombinedView(balanceData) {
    const statusEmoji = window.Lux_statusEmojiMap?.[balanceData.status] || '❓'
    const commentDisplayHtml = balanceData.comment
      ? balanceData.comment.replace(/\n/g, '<br>')
      : '<em>No comment.</em>'
    const canApprove = balanceData.status !== 'approved'
    // Use the postingItemId of the representative balance for actions
    const representativePostingItemId = balanceData.postingItemId

    const commentSection =
      balanceData.status === 'feedback needed from administrator'
        ? `<div
      class="ant-col ant-col-24"
      style="padding-left: 12px; padding-right: 12px;"
    >
      <div class="TextInput">
        <div
          class="ant-row ant-form-item ant-form-item-with-help"
          style="row-gap: 0px"
        >
          <div class="ant-col ant-form-item-label">
            <label class="" title=""
              ><span><span>Kommentar: </span></span></label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="ant-col ant-form-item-control">
  <div class="ant-form-item-control-input">
    <div class="ant-form-item-control-input-content">
      <div
        class="ant-select ant-select-in-form-item Select read-only ant-select-single ant-select-allow-clear ant-select-show-arrow ant-select-disabled ant-select-show-search"
      >
        <div class="ant-select-selector" style="height: auto;">
          <span class="ant-select-selection-item"  title="${commentDisplayHtml}">
          ${commentDisplayHtml}
          </span>
        </div>
      </div>
    </div>
  </div>`
        : ''
    mainContainer.innerHTML += `
      <div class="section-header" role="button" tabindex="0">
        <div class="section-title-wrapper">
          <div class="section-title">Abnahme</div>
        </div>
      </div>
      <div class="section-content">
        <div
          class="ant-row"
          style="margin-left: -12px; margin-right: -12px; row-gap: 24px"
        >
          <div
            class="ant-col ant-col-24"
            style="padding-left: 12px; padding-right: 12px"
          >
            <div class="TextInput">
              <div
                class="ant-row ant-form-item ant-form-item-with-help"
                style="row-gap: 0px"
              >
                <div class="ant-col ant-form-item-label">
                  <label class="" title=""
                    ><span><span>Status: ${statusEmoji}</span></span></label
                  >
                </div>
              </div>
            </div>
          </div>
          ${commentSection}

          <div class="ant-form-item-explain ant-form-item-explain-connected">
            <div role="alert" class="" style="">test</div>
          </div>
        </div>
        <div>
          <button
            class="lux-edit-btn"
            data-posting-item-id="${representativePostingItemId}"
            style="
              padding: 5px 10px;
              cursor: pointer;
              background-color: #ffc107;
              color: black;
              border: none;
              border-radius: 3px;
              margin-right: 10px;
            "
          >
            Bearbeiten
          </button>
          <span
            class="lux-approve-status"
            style="margin-left: 10px; font-style: italic; color: #666"
          ></span>
        </div>
      </div>
      `
  }*/

  function renderView(balances) {
    // Sort balances by posting date ascending
    balances.sort((a, b) => {
      try {
        // Ensure dates are valid before comparing
        const dateA = new Date(a.postingDate)
        const dateB = new Date(b.postingDate)
        if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0 // Keep original order if dates invalid
        return dateA - dateB
      } catch (e) {
        return 0
      } // Keep original order on error
    })

    let sectionsHTML = `
      <div class="section-header" role="button" tabindex="0">
        <div class="section-title-wrapper">
          <div class="section-title">Abnahme</div>
        </div>
      </div>
      `

    if (balances.length > 1) {
      const representativePostingItemId = balances[0].postingItemId
      sectionsHTML += `
            <div class="section-content">
              <div
                class="ant-row"
                style="margin-left: -12px; margin-right: -12px; row-gap: 24px"
              >
                <div
                  class="ant-col ant-col-24"
                  style="padding-left: 12px; padding-right: 12px"
                >
                  <div class="TextInput">
                    <div
                      class="ant-row ant-form-item ant-form-item-with-help"
                      style="row-gap: 0px"
                    >
                      <span>
                        Diese Rechnung ist gehört zu einem Dauerauftrag.
                        Für mehr Informationen klicke bitte auf Bearbeiten.
                        Dort kannst Du auch den Dauerauftrag bearbeiten.
                        Um einzelne Buchungen zu kommentieren, benutze bitte die Übersichtsseite.
                      </span>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="lux-edit-btn"
                  data-posting-item-id="${representativePostingItemId}"
                  style="
                    padding: 5px 10px;
                    cursor: pointer;
                    background-color: #ffc107;
                    color: black;
                    border: none;
                    border-radius: 3px;
                    margin-right: 10px;
                  "
                >
                  Bearbeiten
                </button>
                <span
                  class="lux-approve-status"
                  style="margin-left: 10px; font-style: italic; color: #666"
                >
              </span>
              </div>
            </div>
    `
    } else if (balances.length === 1) {
      balances.forEach((balance) => {
        const statusEmoji = window.Lux_statusEmojiMap?.[balance.status] || '❓'
        const commentDisplayHtml = balance.comment
          ? balance.comment.replace(/\n/g, '<br>')
          : '<em>No comment.</em>'
        const formattedDate = formatDate(balance.postingDate)

        const representativePostingItemId = balance.postingItemId
        const commentSection =
          balance.status === 'feedback needed from administrator'
            ? `<div
                class="ant-col ant-col-24"
                style="padding-left: 12px; padding-right: 12px"
              >
                <div class="TextInput">
                  <div
                    class="ant-row ant-form-item ant-form-item-with-help"
                    style="row-gap: 0px"
                  >
                    <div class="ant-col ant-form-item-label">
                      <label class="" title=""
                        ><span><span>Kommentar: </span></span></label
                      >
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                <div
                  class="ant-select ant-select-in-form-item Select read-only ant-select-single ant-select-allow-clear ant-select-show-arrow ant-select-disabled ant-select-show-search"
                >
                  <div class="ant-select-selector" style="height: auto;">
                    <span class="ant-select-selection-item"  title="${commentDisplayHtml}">
                    ${commentDisplayHtml}
                    </span>
                  </div>
                </div>
              </div>
            </div>`
            : ''
        sectionsHTML += `
            <div class="section-content">
              <div
                class="ant-row"
                style="margin-left: -12px; margin-right: -12px; row-gap: 24px"
              >
                <div
                  class="ant-col ant-col-24"
                  style="padding-left: 12px; padding-right: 12px"
                >
                  <div class="TextInput">
                    <div
                      class="ant-row ant-form-item ant-form-item-with-help"
                      style="row-gap: 0px"
                    >
                      <div class="ant-col ant-form-item-label">
                        <label class="" title=""
                          ><span><span>Datum: ${formattedDate}</span></span></label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="ant-col ant-col-24"
                  style="padding-left: 12px; padding-right: 12px"
                >
                  <div class="TextInput">
                    <div
                      class="ant-row ant-form-item ant-form-item-with-help"
                      style="row-gap: 0px"
                    >
                      <div class="ant-col ant-form-item-label">
                        <label class="" title=""
                          ><span><span>Status: ${statusEmoji}</span></span></label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                ${commentSection}
    
                <div class="ant-form-item-explain ant-form-item-explain-connected">
                  <div role="alert" class="" style="">test</div>
                </div>
              </div>
              <div>
                <button
                  class="lux-edit-btn"
                  data-posting-item-id="${representativePostingItemId}"
                  style="
                    padding: 5px 10px;
                    cursor: pointer;
                    background-color: #ffc107;
                    color: black;
                    border: none;
                    border-radius: 3px;
                    margin-right: 10px;
                  "
                >
                  Bearbeiten
                </button>
                <span
                  class="lux-approve-status"
                  style="margin-left: 10px; font-style: italic; color: #666"
                >
              </span>
              </div>
            </div>
    `
      })
    } else {
      sectionsHTML += '<div>Keine Buchungen zu dieser Rechnung gefunden.</div>'
    }

    mainContainer.innerHTML += sectionsHTML
  }

  // --- Action Handlers ---
  async function handleEditClick(postingItemId) {
    console.log(`Edit clicked for postingItemId: ${postingItemId}`)
    // Create controller ON DEMAND
    activeController = new AccountBalanceStatusController(postingItemId)

    // Attach listeners to THIS controller instance
    // These listeners interact with the modal
    // Listener to refresh UI after successful approval
    activeController.on('approveSuccess', async (eventData) => {
      // Modified to accept eventData
      if (typeof Lux_Modal_hideStatusModal === 'function')
        Lux_Modal_hideStatusModal()
      activeController = null // Clear controller reference
      await fetchAndRenderBalances() // Re-fetch all balances and re-render the section
    })
    // Listener to refresh UI after successful save
    activeController.on('saveSuccess', async (eventData) => {
      // Modified to accept eventData
      console.log(
        'Save successful, hiding modal and refreshing UI...',
        eventData
      )
      if (typeof Lux_Modal_hideStatusModal === 'function')
        Lux_Modal_hideStatusModal()
      activeController = null // Clear controller reference
      await fetchAndRenderBalances() // Re-fetch all balances and re-render the section
      console.log('Comment saved!', 'success')
    })

    // Show the modal, passing the controller
    Lux_Modal_showStatusModal(
      activeController,
      currentBalances.length > 1 ? 'standing order' : 'single order',
      user
    )

    // --- Fetch initial data ---
    // Fetching after showing modal allows modal to display loading state
    await activeController.fetchInitialData()
  }

  // --- Delegated Click Handler ---
  const handleDelegatedClick = (event) => {
    const clickedButton = event.target.closest('button')
    if (!clickedButton || !mainContainer) return

    const postingItemIdStr = clickedButton.dataset.postingItemId

    if (clickedButton.classList.contains('lux-edit-btn') && postingItemIdStr) {
      handleEditClick(parseInt(postingItemIdStr, 10))
    }
  }

  // --- Main Data Fetching and Rendering Function ---
  async function fetchAndRenderBalances() {
    if (!mainContainer) {
      console.error('Main container not found for fetching balances.')
      return
    }
    mainContainer.innerHTML = '<p>Lädt...</p>' // Show loading

    // 1. Get Invoice ID (determine finalExchangePlanId)
    const urlParams = new URLSearchParams(window.location.search)
    const sourceIdStr = urlParams.get('sourceId')
    let finalExchangePlanId = null // This will hold the ID used for fetching balances

    if (sourceIdStr) {
      // Case 1: sourceId is in the URL query parameters
      finalExchangePlanId = parseInt(sourceIdStr, 10)
      if (isNaN(finalExchangePlanId)) {
        mainContainer.innerHTML =
          '<p style="color: red;">Fehler: Ungültige sourceId in URL-Parametern.</p>'
        return
      }
      console.log(`Using sourceId from query params: ${finalExchangePlanId}`)
    } else {
      // Case 2: sourceId is NOT in query params, try to use invoiceHrId from path
      const path = window.location.pathname
      const urlRegex =
        /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+\/invoice\/edit\/([^?]+)$/
      const match = path.match(urlRegex)
      let invoiceHrIdFromPath = null

      if (match && match.length > 1) {
        invoiceHrIdFromPath = match[1]
        console.log(`Found invoiceHrId in path: ${invoiceHrIdFromPath}`)
      } else {
        mainContainer.innerHTML =
          '<p style="color: red;">Fehler: Weder sourceId noch invoiceHrId in der URL gefunden.</p>'
        return
      }

      // Now, fetch sourceId using invoiceHrIdFromPath
      try {
        mainContainer.innerHTML = ''
        const response = await Lux_ApiClient_get(
          `/api/invoices/${invoiceHrIdFromPath}`
        )

        if (response.ok) {
          const invoiceData = await response.json()
          if (invoiceData && invoiceData.id) {
            finalExchangePlanId = parseInt(invoiceData.id, 10)
            if (isNaN(finalExchangePlanId)) {
              mainContainer.innerHTML =
                '<p style="color: red;">Fehler: Ungültige ID von API erhalten.</p>'
              return
            }
            console.log(
              `Successfully fetched sourceId: ${finalExchangePlanId} for invoiceHrId: ${invoiceHrIdFromPath}`
            )
          } else {
            mainContainer.innerHTML =
              '<p style="color: red;">Fehler: ID nicht in API-Antwort für die gegebene invoiceHrId gefunden.</p>'
            return
          }
        } else if (response.status === 404) {
          mainContainer.innerHTML = `<p style="color: red;">Fehler: Rechnung mit HR-ID ${invoiceHrIdFromPath} nicht gefunden.</p>`
          return
        } else {
          const errorData = await response.json().catch(() => ({}))
          mainContainer.innerHTML = `<p style="color: red;">Fehler (${
            response.status
          }) beim Abrufen der Rechnungsdetails für HR-ID ${invoiceHrIdFromPath}: ${
            errorData.error || 'Unbekannter Fehler'
          }</p>`
          return
        }
      } catch (error) {
        console.error('Error fetching sourceId by invoiceHrId:', error)
        mainContainer.innerHTML = `<p style="color: red;">Fehler beim Abrufen der internen Rechnungs-ID: ${error.message}</p>`
        return
      }
    }

    // At this point, finalExchangePlanId should be a valid number if we haven't returned.
    if (finalExchangePlanId === null || isNaN(finalExchangePlanId)) {
      mainContainer.innerHTML =
        '<p style="color: red;">Fehler: Rechnungs ID konnte nicht ermittelt werden.</p>'
      return
    }

    // 2. Get Dates from localStorage
    // let startDate, endDate; // Moved to global state: currentDateRange
    try {
      const dateRangeString = localStorage.getItem(localStorageKey)
      if (dateRangeString) {
        const dateRange = JSON.parse(dateRangeString)
        currentDateRange.startDate = dateRange.startDate // Store globally
        currentDateRange.endDate = dateRange.endDate // Store globally

        console.log(
          `Using date range from localStorage: ${currentDateRange.startDate} to ${currentDateRange.endDate}`
        )
      } else {
        // Handle missing dates - maybe default to current year or show error?
        // For now, show error.
        throw new Error('Date range not found in localStorage.')
      }
    } catch (e) {
      console.error('Error loading/parsing date range from localStorage:', e)
      mainContainer.innerHTML = `<p style="color: red;">Error: Could not load required date range. Please visit the account balances overview page first.</p>`
      return
    }

    // 3. Fetch Balances from API
    try {
      const response = await Lux_ApiClient_get(
        `/api/account-balances?exchangePlanIds=${finalExchangePlanId}&startDate=${currentDateRange.startDate}&endDate=${currentDateRange.endDate}`
      )

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.error || `API Error: ${response.status}`)
      }

      currentBalances = await response.json() // Expecting array response
      renderUI(currentBalances)
    } catch (error) {
      console.error('Error fetching balances:', error)
      mainContainer.innerHTML = `<p style="color: red;">Error loading balance details: ${error.message}</p>`
    }
  }

  // --- Initialization Logic ---
  const initializeLogic = () => {
    const anchorElement = document.querySelector(anchorSelector)

    if (document.getElementById(containerId)) {
      console.log('Lux Inject: Balances section already initialized.')
      return // Prevent re-initialization
    }

    console.log('Lux Inject: Initializing invoice balance section...')

    mainContainer = document.createElement('div')
    mainContainer.id = containerId
    mainContainer.style.position = 'relative'
    anchorElement.parentNode.insertBefore(mainContainer, anchorElement)

    // Initial fetch and render
    fetchAndRenderBalances()
  }

  // --- Use Interval to wait for anchor ---
  if (user === 'advisory council' || window.Lux_auditObserver) {
    const checkInterval = setInterval(() => {
      // Check for anchor AND ensure container hasn't been added yet
      if (
        document.querySelector(anchorSelector) &&
        !document.getElementById(containerId)
      ) {
        clearInterval(checkInterval)
        initializeLogic()
      }
    }, 500)
  }
}
